import axiosInstance from "../../../helpers/api";

// Get last live video
export const getLastLiveVideo = (courseId) => {
  return axiosInstance.get(`/student/live_videos?course_id=${courseId}`);
};

// Save live video seen
export const saveLiveVideoSeen = (data) => {
  return axiosInstance.post("/student/live_videos", data);
}; 